/* Section reveal-on-scroll.

   SAFETY FIRST. A reveal effect that hides content and depends on JS to show
   it again is one failed assumption away from an invisible storefront. The
   first version of this file proved the point: IntersectionObserver did not
   fire for 7 of 10 sections on the homepage (Be-Yours wraps the page in a
   transition container, which interferes with the observer's geometry), and
   those sections stayed at opacity 0 after a full scroll of the page.

   So there are now THREE independent ways a section becomes visible, and the
   effect is purely decorative on top of them:
     1. IntersectionObserver, the intended path
     2. a scroll listener, in case the observer never fires
     3. a hard 2.5s timeout that reveals EVERYTHING regardless

   Nothing is hidden by CSS alone: this script adds [data-hm-reveal] itself and
   removes it from any element it gives up on, so a blocked, failed or throwing
   script leaves the page fully readable. */
(function () {
  'use strict';

  function run() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var sections = Array.prototype.slice.call(document.querySelectorAll('#MainContent .shopify-section'));
    if (!sections.length) return;

    var pending = [];
    sections.forEach(function (el) {
      // already on screen at load: animating it reads as jank, leave it be
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      el.setAttribute('data-hm-reveal', '');
      pending.push(el);
    });
    if (!pending.length) return;

    function reveal(el) {
      el.classList.add('hm-revealed');
      var i = pending.indexOf(el);
      if (i > -1) pending.splice(i, 1);
    }
    function revealAll() {
      pending.slice().forEach(reveal);
    }

    // 1. the intended path
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -5% 0px', threshold: 0 });
      pending.forEach(function (el) { io.observe(el); });
    }

    // 2. belt and braces: plain scroll maths, in case the observer is confused
    //    by the theme's transition wrapper
    var onScroll = function () {
      pending.slice().forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.95) reveal(el);
      });
      if (!pending.length) window.removeEventListener('scroll', onScroll);
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    // 3. hard stop. Whatever happened above, nothing stays hidden.
    window.setTimeout(revealAll, 2500);
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  } catch (e) {
    // never let a decorative effect break the page
    document.querySelectorAll('[data-hm-reveal]').forEach(function (el) {
      el.removeAttribute('data-hm-reveal');
    });
  }
})();
